import React, { useEffect, useRef } from "react";
import IconArrowLeft from "./ArrowLeft";
import IconArrowRight from "./ArrowRight";

declare var Flickity: any;

const CarouselNavigation = ({
  carouselRef,
  shiftPageDots = true,
  spread = false,
  onPrevious,
  onNext,
  icons,
  size
}) => {
  const dotsContainerRef: any = useRef(null);

  const handlePrevClick = (e) => {
    console.log("Previous clicked");
    e.preventDefault();

    if (onPrevious) return onPrevious();

    if (carouselRef.current) {
      if (typeof Flickity !== "undefined") {
        Flickity.data(carouselRef.current).previous();
      }
    }
  };

  const handleNextClick = (e) => {
    console.log("Next clicked");
    e.preventDefault();

    if (onNext) return onNext();

    if (carouselRef.current) {
      if (typeof Flickity !== "undefined") {
        Flickity.data(carouselRef.current).next();
      }
    }
  };

  useEffect(() => {
    if (shiftPageDots && dotsContainerRef.current && carouselRef.current) {
      const observer = new MutationObserver(() => {
        const flickityDots = carouselRef.current.querySelector(
          ".flickity-page-dots",
        );
        if (flickityDots) {
          dotsContainerRef?.current?.appendChild(flickityDots);
          observer.disconnect(); // Stop observing once the dots have been moved
        }
      });

      observer.observe(carouselRef.current, { childList: true, subtree: true });
    }
  }, [shiftPageDots]);

  return (
    <>
      <div ref={dotsContainerRef} className="flickity-dots-container" />
      <div
        className={`carousel-nav ${spread ? "flex justify-between items-center w-full z-[5] absolute top-1/2 transform -translate-y-1/2" : "flex gap-[12px]"}`}
      >
        <IconArrowLeft size={size || 36} onClick={handlePrevClick} icon={icons?.carousel_navigation_arrow_left}/>
        {!spread && <div className="flex-grow" />}
        <IconArrowRight size={size || 36} onClick={handleNextClick} icon={icons?.carousel_navigation_arrow_right}/>
      </div>
    </>
  );
};

export default CarouselNavigation;
